import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getMortarSales, getMortarSalesPriceForStone } from '@/service/sale/salePrice';
export default function useMortarList(params) {
  var mortarList = ref([]);
  // 获取主机汇总数据
  var getMortarSalesAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMortarSales();
          case 2:
            data = _context.sent;
            mortarList.value = data.list;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getMortarSalesAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var mortarPriceList = ref([]);
  var getMortarPriceForStoneAsync = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getMortarSalesPriceForStone(params.value);
          case 2:
            data = _context2.sent;
            mortarPriceList.value = data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getMortarPriceForStoneAsync() {
      return _ref2.apply(this, arguments);
    };
  }();
  return [mortarList, mortarPriceList, getMortarSalesAsync, getMortarPriceForStoneAsync];
}